<template>
  <PmwAlertModal
    v-bind="$attrs"
    :confirmButtonText="'Sim, quero utilizar'"
    :closeButton="true"
    :preventOverlayClick="true"
    icon="pmw-alert"
    class="clipboard-alert"
    @alert-modal-confirm="$emit('alert-modal-confirm')"
    @alert-modal-cancel="$emit('alert-modal-cancel')"
  >
    <template #text>
      <span>
        Identificamos que você tem cores na sua área de transferência. Gostaria
        de utilizá-las?
      </span>
    </template>
  </PmwAlertModal>
</template>

<script>
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

export default {
  name: 'ClipboardAlert',

  components: {
    PmwAlertModal
  }
}
</script>
